import script from "./utrpayment.vue?vue&type=script&setup=true&lang=js"
export * from "./utrpayment.vue?vue&type=script&setup=true&lang=js"

import "./utrpayment.vue?vue&type=style&index=0&id=5aeec47c&scoped=true&lang=less"

import exportComponent from "C:\\Users\\20303\\Desktop\\yesant\\code\\novapay\\syt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aeec47c"]])

export default __exports__